import {Input, Modal} from "antd";
import React, {useState} from "react";
import FilterButton from "../../piece/FilterButton";
import {FieldTimeOutlined} from "@ant-design/icons";

export default (props) => {
    const [visible, setVisible] = useState(false)
    const [startYear, setStartYear] = useState(null)
    const [endYear, setEndYear] = useState(null)

    return (
        <>
            <FilterButton
                onClick={() => {
                    setVisible(true)
                }}
            >
                <FieldTimeOutlined/> Creation Year
            </FilterButton>
            <Modal
                title='Creation Year Filter'
                visible={visible}
                open={visible}
                onOk={() => {
                    setVisible(false)
                    if (props.onChange) {
                        props.onChange({
                            startDateFilter: {
                                text: 'Min Year',
                                value: startYear
                            },
                            endDateFilter: {
                                text: 'Max Year',
                                value: endYear
                            }
                        })
                    }
                }}
                onCancel={() => {
                    setVisible(false)
                }}
            >
                <Input
                    key={'input_minimum_year'}
                    placeholder='Please input the minimum filterable year, ex.2012'
                    onChange={(e) => {
                        setStartYear(e.target.value)
                    }}
                />
                <Input
                    key={'input_maximum_year'}
                    style={{marginTop: '16px'}}
                    placeholder='Please input the maximum filterable year'
                    onChange={(e) => {
                        setEndYear(e.target.value)
                    }}
                />
            </Modal>
        </>
    )
}